/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RotorWingShiftsResponse } from '../../models/rotor-wing-shifts-response';

export interface ListRotorWingShifts$Params {
  base: string;
}

export function listRotorWingShifts(http: HttpClient, rootUrl: string, params: ListRotorWingShifts$Params, context?: HttpContext): Observable<StrictHttpResponse<RotorWingShiftsResponse>> {
  const rb = new RequestBuilder(rootUrl, listRotorWingShifts.PATH, 'get');
  if (params) {
    rb.query('base', params.base, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RotorWingShiftsResponse>;
    })
  );
}

listRotorWingShifts.PATH = '/api/scheduler/daily-line-schedule/rotor-wing/shifts';
